// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"18dc76d8","196":"6e132811","693":"6bdf336f","813":"8857ca01"}[chunkId] + ".chunk.css";
};